import { render, staticRenderFns } from "./PaidWarrantsProcessedDetails.vue?vue&type=template&id=5448f8fc&"
import script from "./PaidWarrantsProcessedDetails.vue?vue&type=script&lang=js&"
export * from "./PaidWarrantsProcessedDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports